export default __webpack_public_path__ + "static/media/fast-forward-desc.c71f2c79.png";